<template>
    <div
        :class="[{ isDisabled: isExpired }, 'leftImgContainer']"
    >
        <a
            class="left-img-container"
            :href="contentData.fields.linkUrl"
            :data-spm-content="`||${this.uuid}||`"
            data-spm-data="g"
            @click="sendAction(8890, $event)"
        >
            <div class="img">
                <img :src="contentData.fields.image" class="art-insert-img" />
            </div>
            <div class="left-img-content">
                <div
                    :class="[
                        'img-title',
                        {
                            column2:
                                (contentData.fields.btnText && !isExpired) ||
                                contentData.fields.desc,
                        },
                    ]"
                >
                    {{ contentData.cardName }}
                </div>
                <div class="right-container">
                    <div class="img-info">
                        <span
                            :class="['img-brief']"
                            v-if="contentData.fields.desc"
                            >{{ contentData.fields.desc }}</span
                        >
                    </div>
                    <div class="btnContainer">
                        <span
                            class="img-link-btn"
                            v-if="
                                contentData.fields.btnText && !isExpired
                            "
                            >{{ contentData.fields.btnText }}</span
                        >
                    </div>
                </div>
            </div>
        </a>
        <card-bottom :data="contentData"></card-bottom>
    </div>
</template>

<style lang="less" scoped>
@import "../../../less/base/mixins.less";
.leftImgContainer {
    margin-bottom: 40px;
    .left-img-container {
        display: flex;
        height: 206px;
        border: 1px solid rgba(229, 229, 229, 1);
        background: #ffffff;
        .art-insert-img {
            width: 206px;
            height: 206px;
            margin-bottom: 0;
        }
        .left-img-content {
            padding: 20px 26px;
            display: flex;
            width: 100%;
            flex-direction: column;
            align-content: space-between; /* 竖向中间自动空间 */
            .img-title {
                font-family: PingFang SC;
                font-weight: 500;
                color: #3c3c3d;
                line-height: 39px; /*px*/
                font-size: 32px; /*px*/
            }
            .column2 {
                overflow: hidden;
                .line-clamp(2);
            }
            .right-container {
                margin-top: 14px;
                flex: 1;
                display: flex;
                align-items: center;
                .btnContainer {
                    display: flex;
                    align-items: flex-end;
                    .img-link-btn {
                        float: right;
                        background: rgba(245, 245, 245, 1);
                        font-family: PingFang SC;
                        font-weight: bold;
                        color: rgba(249, 74, 37, 1);
                        height: 56px; /*px*/
                        min-width: 160px; /*px*/
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 26px !important; /*px*/
                        border-radius: 1rem; /*px*/
                    }
                }
                .img-info {
                    flex: 1;
                    .img-brief {
                        font-family: PingFang SC;
                        color: #a4a4a4;
                        line-height: 40px;
                        font-size: 28px !important; /*px*/
                        overflow: hidden;
                        .line-clamp(2);
                    }
                }
            }
        }
    }
}
.isDisabled {
    opacity: 0.5;
}
</style>

<script>
import cardBottom from "./../common/cardBottom.vue";
export default {
    data() {
        return {};
    },
    components: {
        cardBottom,
    },
    computed: {
        contentData() {
            return this.articleData;
        },
        // 下线&过期状态
        isExpired() {
            const statuslist = [3, 4]
            return statuslist.includes(this.contentData.status) 
        },
    },
    methods: {
        sendAction(acode, e) {
            if (this.isExpired) {
                //阻止默认事件

                e.preventDefault();
                return false;
            }
            if (
                window.sohuSpm &&
                typeof window.sohuSpm.sendAction === "function"
            ) {
                window.sohuSpm.sendAction({
                    acode: acode,
                });
            }
        },
    },
};
</script>
